import {default as parentScope } from '../types';
const SCOPE = `${parentScope}.mbrPolicy`;
export default SCOPE;

export const INIT = `${SCOPE}/INIT`;
export const SET_DATA = `${SCOPE}/SET_DATA`;
export const TOGGLE_LOADING = `${SCOPE}/TOGGLE_LOADING`;
